import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { NotificationService } from '@vantage-platform/toastr';
import { InsightService } from '@vantage-platform/app-insight';
import { TranslateService } from '@ngx-translate/core';

const EXCLUDE_URLS = [
  'api.powerbi.com'
];

@Injectable()
export class AuthErrorsInterceptor implements HttpInterceptor {

  private translate: TranslateService | null = null;

  constructor(
    private router: Router,
    private auth: AuthService,
    private notificationService: NotificationService,
    private insights: InsightService,
    private injector: Injector
  ) {}

  private getTranslateService(): TranslateService {
    if (!this.translate) {
      this.translate = this.injector.get(TranslateService);
    }
    return this.translate;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {  
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg = '';

        if (error.error instanceof ErrorEvent) {
          // Client-side error
          console.log(`Error: ${error.error.message}`);
        } else {
          // Server-side error
          switch (error.status) {
          case 401:
            // Exclude URLs from 401 handling so service can handle it
            if (EXCLUDE_URLS.some(url => request.url.includes(url))) {
              return throwError(() => error);
            }
            errorMsg = this.getTranslateService().instant('errors.unauthorized');
            this.insights.error(error);
            // Handle 401 Unauthorized error
            // Redirect user to the login page or show an alert
            this.auth.logOut();
            this.router.navigate(['/login']);
            break;
          case 400:
          case 403:
          case 404:
          case 408:
          case 500:
          case 502:
          case 503:
          case 504:
            errorMsg = this.getTranslateService().instant('errors.generic');
            break;
          case 409:
            // Do not handle here, let the component/service handle it
            return throwError(() => error);
          default:
            errorMsg = this.getTranslateService().instant('errors.generic');
            break;
          }
        }

        this.insights.error(error); // log error to azure insights
        this.notificationService.info(errorMsg);
        return throwError(() => new Error(errorMsg));
      })
    );
  }
}
